import { privateInstance } from "../configs";
import { mappers } from "@/mappers";

export const orderTemplateApi = {
  async getOrderTemplates() {
    const res = await privateInstance.get(`/recipes/api/order/template/`);
    return res.data.map(x => mappers.mapDeliverySlipTemplate(x));
  },
  async retrieveOrderTemplate(id) {
    const res = await privateInstance.get(`/recipes/api/order/template/${id}/`);
    return mappers.mapDeliverySlipTemplate(res.data);
  },
  async postOrderTemplate(template) {
    const res = await privateInstance.post(
      `/recipes/api/order/template/`,
      template
    );
    return mappers.mapDeliverySlipTemplate(res.data);
  },
  async putOrderTemplate(id, template) {
    const res = await privateInstance.put(
      `/recipes/api/order/template/${id}/`,
      template
    );
    return mappers.mapDeliverySlipTemplate(res.data);
  },
  async deleteOrderTemplate(id) {
    const res = await privateInstance.delete(
      `/recipes/api/order/template/${id}/`
    );
    return mappers.mapDeliverySlipTemplate(res.data);
  },
  async copyOrderTemplate(id, toStore) {
    await privateInstance.post(`/recipes/api/debug/order/template/copy/`, {
      id: id,
      store: toStore
    });
  }
};
